<template>
    <pm-custom-dialog v-if="visible" v-model="visible" id="pm-video-dialog">
        <div slot="close-btn" @click="logClose" style="position: absolute; width: 28px; height: 28px; background: #fff; line-height: 22px; text-align: center; top: 32px; right: 12px; border: 2px solid #ddd; border-radius: 50%;" class="main-dialog--close">
            <span style="font-weight: 600;"><v-icon style="font-size: 16px;">close</v-icon></span>
        </div>

        <div style="position: relative; background: #fff; border-radius: 8px; text-align: center; margin: 0; padding: 0; height: auto;">
            <video id="simpleVideo" @ended="onVideoEnded" @error="onVideoError" ref="video" playsinline muted autoplay style="display: block; margin: 0; padding: 0; width: 100%;">
                <source @error="onVideoError" playsinline v-if="supportsHLS" src="https://cdn.denticalc.com/videos/smart-tutorial-v3_720_v4.m3u8" type="application/x-mpegURL">
                <source @error="onVideoError" playsinline src="https://cdn.denticalc.com/videos/smart-tutorial-v3_720_v4.mp4" type="video/mp4">
            </video></div>
    </pm-custom-dialog>
</template>

<style>
    #pm-video-dialog .pm-custom-dialog-content {
        background: none;
        box-shadow: none;
    }
    #pm-video-dialog video {
        width: 100%;
        border-radius: 8px;
    }
</style>

<script>
import PmCustomDialog from "./base-dialog.vue";
import { logVideoPlayThrough } from "@/utils/analytics/usage.ts";
import { supportsHLS } from "../../utils/device/media-support";
export default {
    components: {
        PmCustomDialog
    },
    data: () => ({
        visible: false,
        videoStarted: false,
        warningShown: 0,
    }),
    created() {

    },
    computed: {
        supportsHLS() {
            return supportsHLS();
        },
    },
    methods: {
        onVideoError() {
            this.close();
        },
        onVideoEnded() {
            logVideoPlayThrough(document.getElementById("simpleVideo"));
            this.close();
            this.$bus.$emit("app.hideSnackbar");
            localStorage.setItem("smartVideoViewed", "1");
        },
        show() {
            this.visible = true;
        },
        close() {
            this.visible = false;
            this.$emit('close');
        },
        logClose() {
            if (!this.$isIOS() && !this.warningShown && this.$router.currentRoute.path === "/plan") {
                this.$bus.$emit("app.showSnackbar", {color: "red", text: "<span style='font-weight: 600; font-size: 14px;'>This video is essential. PLEASE WATCH IT!</span><br/>It only takes 2 minutes.", timeout: 5000});
                this.warningShown = 1;
                return;
            }

            try {
                const el = document.getElementById("simpleVideo");
                if (el instanceof HTMLVideoElement) {
                    const viewedPercentage = Math.ceil((el.currentTime / el.duration) * 100);
                    // alert(viewedPercentage);
                    if (viewedPercentage > 90) localStorage.setItem("smartVideoViewed", "1");
                    else localStorage.setItem("smartVideoClosed", "1");
                    logVideoPlayThrough(document.getElementById("simpleVideo"));
                } else {
                   localStorage.setItem("smartVideoClosed", "1");
                }
            } catch (error) {
                window.captureException(error);
                localStorage.setItem("smartVideoClosed", "1");
            }
            this.close();
        },
        showInfo() {
            if (this.$isIOS() || this.warningShown) this.close();
            else {
                this.$bus.$emit("app.showSnackbar", {color: "blue", text: "This video is essential to understand how SMART works. Please watch it.", timeout: 3000});
                this.warningShown = 1;
            }
        },
    }
}
</script>
